<template>
  <div id="privacyLockout">
    
    <div style="text-align: center">Our <a href="https://app.vilio.co/policy" target="_blank">Terms of Service and Privacy Policy</a> have been updated.</div>
    <br>
    
    <div>
      To continue using Vilio, you must agree to our updated <a href="https://app.vilio.co/policy" target="_blank">Terms of Service and Privacy Policy</a>.
    </div>
    <br>
    
    <div class="checkbox-container">
      <v-checkbox color="primary" hide-details v-model="agree">
        <div class="label-section" slot="label">
          <div class="name">I have read and agree to the Terms of Service and Privacy Policy.</div>
        </div>
      </v-checkbox>
    </div>
  </div>
</template>

<script>

  export default {
    data () {
      return {
        agree: false
      }
    },

    methods: {
      action () {        
        if (this.agree) {
          return this.$store.dispatch('saveProfile', {
            user: {
              tosLastRead: Date.now()
            }
          })
        }
        else {
          Toast.show('You must agree to our Terms of Service and Privacy Policy to continue.', 'error');
          return Promise.reject();
        }
      }
    }
  }

</script>

<style lang="scss">
  
  @import '../css/global.scss';

  #privacyLockout {

    label {
      position: relative !important;
      height: auto !important;
      white-space: normal;
    }

    .checkbox-container {
      padding: 16px 0 0;
      border-top: $borderBlack12;
    }
    
    .input-group__input {
      min-height: 0 !important;
      position: absolute;
    }

    .input-group--selection-controls__ripple {
      transform: translate(-12px,-21%);
    }

    .input-group__input .icon--selection-control {
      top: 45%;
    }

    .input-group__input {
      top: 10px;
    }

  }

</style>


// WEBPACK FOOTER //
// src/components/PrivacyLockout.vue